import React from "react";
import { getDirectionalText } from "@/lib/textDirection";

export default function DirectionalText({ as: Element = "span", children, style, ...props }) {
  const { text, dir } = getDirectionalText(children);

  return (
    <Element
      {...props}
      dir={dir}
      style={{ direction: dir, unicodeBidi: "isolate", ...style }}
    >
      {text}
    </Element>
  );
}
